import { Loggable, Logger, RestClient } from '@reyaxyz/common';

import {
  GetWalletReferralCodeParams,
  GetWalletReferralCodeResult,
  GetWalletReferralDetailsParams,
  GetWalletReferralDetailsResult,
} from './types';

export default class LGEModule extends RestClient implements Loggable {
  loggingEnabled: boolean = false;

  constructor(apiUrl: string, loggingEnabled: boolean) {
    super(apiUrl);
    this.loggingEnabled = loggingEnabled;
  }

  @Logger('ReferralModule.getWalletReferralDetails')
  async getWalletReferralDetails(params: GetWalletReferralDetailsParams) {
    return this.getWalletReferralDetailsV4(params);
  }

  @Logger('ReferralModule.getWalletReferralDetailsV4')
  async getWalletReferralDetailsV4(params: GetWalletReferralDetailsParams) {
    const uri = `/api/xp/get-referral-profile-v4/${params.address}`;
    return this.get<GetWalletReferralDetailsResult>(uri);
  }

  @Logger('ReferralModule.getWalletReferralCode')
  async getWalletReferralCode(params: GetWalletReferralCodeParams) {
    const uri = `/api/xp/get-referral-code/${params.address}`;
    return this.get<GetWalletReferralCodeResult>(uri);
  }
}
